import { axiosInstance } from '../../core/apiConfig';
import {
  BankInformationResponse,
  CreditCardRequestProps,
  CreditCardResponse,
  getHalfPaymentResponse,
  PaymentClientReturn,
  Response,
} from './types';

export const PaymentClient = (): PaymentClientReturn => {
  async function setPlaidManualVerification(body: any) {
    try {
      await axiosInstance.post(`/payments/plaid-manually-verification/`, body);
      return [undefined, undefined];
    } catch (error) {
      return [undefined, error];
    }
  }

  async function setRecurringPayments(body: any) {
    try {
      await axiosInstance.post(`/payments/recurring/`, body);
      return [undefined, undefined];
    } catch (error) {
      return [undefined, error];
    }
  }

  async function markBankAccountAsVierified(body: any) {
    try {
      await axiosInstance.patch(
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        `/payments/bank-account-verified/`,
        body
      );

      return [undefined, undefined];
    } catch (error) {
      return [undefined, error];
    }
  }

  async function calculateFee(uuid: string) {
    try {
      const res = await axiosInstance.get(`/payments/calculate-fee/`, {
        params: { uuid },
      });
      const data = res.data.data;
      return [data, undefined];
    } catch (error) {
      return [undefined, error];
    }
  }

  async function createPlaidLinkToken(body: any) {
    try {
      const res = await axiosInstance.post(`/payments/plaid-link-token/`, body);

      const data = res.data.data;
      return [data, undefined];
    } catch (error) {
      return [undefined, error];
    }
  }

  async function paymentInfo(cfUuid: any) {
    try {
      const res = await axiosInstance.get(`/payments/payment-info`, {
        params: {
          cf_uuid: cfUuid,
        },
      });
      const data = res.data.data;
      return [data, undefined];
    } catch (error) {
      return [undefined, error];
    }
  }

  async function connectCreditCard({
    cfUuid,
    date,
    ...creditCardProps
  }: CreditCardRequestProps): Promise<Response<CreditCardResponse>> {
    const [month, year] = date.split('/');

    try {
      const { data } = await axiosInstance.post<CreditCardResponse>(
        `/payments/recurring/credit-card/`,
        {
          cf_uuid: cfUuid,
          exp_month: month,
          exp_year: year,
          ...creditCardProps,
        }
      );
      return [data, undefined];
    } catch (error) {
      return [undefined, error];
    }
  }

  async function getUserPaymentInformation(
    cfUuid: string
  ): Promise<Response<BankInformationResponse>> {
    try {
      const url = `/payments/payment-info?cf_uuid=${cfUuid}`;
      const { data } = await axiosInstance.get<{
        data: BankInformationResponse;
      }>(url);
      return [data.data, undefined];
    } catch (error) {
      return [undefined, error];
    }
  }

  async function getHalfPayment(
    managementFee: number,
    monthlyPayment: number
  ): Promise<Response<getHalfPaymentResponse>> {
    try {
      const url = `/half-payment/?managementFee=${managementFee}&monthlyPayment=${monthlyPayment}`;

      const { data } = await axiosInstance.get<{
        data: getHalfPaymentResponse;
      }>(url);

      return [data.data, undefined];
    } catch (error) {
      return [undefined, error];
    }
  }
  
  

  return {
    calculateFee,
    setPlaidManualVerification,
    setRecurringPayments,
    markBankAccountAsVierified,
    createPlaidLinkToken,
    connectCreditCard,
    paymentInfo,
    getUserPaymentInformation,
    getHalfPayment,
  };
};
